import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { ValidatorForm } from 'react-material-ui-form-validator';

import Box from '@quintoandar/cozy-core/Box';
import Field from '@quintoandar/cozy-core/Field';
import Input from '@quintoandar/cozy-core/Input/Input';

import CondoName from '../CondoName/index.js';

import { SECTIONS } from '../constants.js';

import messages from '../HouseAddress/messages.js';
import { HOUSE_ADDRESS_ITEMS } from '../HouseAddress/constants.js';

const TYPE_NOT_ALLOWED = 'house';

const HouseAddress = ({ photoSessionDetail, onChangeItem, house, shouldValidate, checkCondoNameIsValid }) => {
  const onChangeComponent = ({ key }) => (event) => {
    const houseAddressItems = house.items;
    const value = event.target.value;

    const onChangeParams = {
      section: SECTIONS.HOUSE,
      itemSlug: key,
      value,
      houseAddressItems: {
        ...houseAddressItems,
        [key]: {
          value,
        },
      },
      previousValue: house.items[key].value,
    };

    onChangeItem(onChangeParams);
  };

  const handleCondoName = (value) => {
    const houseAddressItems = house.items;

    const onChangeParams = {
      section: SECTIONS.HOUSE,
      itemSlug: HOUSE_ADDRESS_ITEMS.CONDO_NAME,
      value,
      houseAddressItems: {
        ...houseAddressItems,
        [HOUSE_ADDRESS_ITEMS.CONDO_NAME]: {
          value,
        },
      },
      previousValue: house.items[HOUSE_ADDRESS_ITEMS.CONDO_NAME].value,
    };

    onChangeItem(onChangeParams);
  };

  return (
    <Fragment>
      <ValidatorForm>
        {house.items.tipo?.value !== TYPE_NOT_ALLOWED ? <CondoName
          photoSessionDetail={photoSessionDetail}
          handleCondoName={handleCondoName}
          house={house}
          shouldValidate={shouldValidate}
          checkCondoNameIsValid={checkCondoNameIsValid}
        /> : null}
        <Box my={3}>
          <Field label={messages.address}>
            <Input
              value={photoSessionDetail.house.address}
              disabled
              fullWidth
            />
          </Field>
        </Box>
        <Box display="flex" my={3}>
          <Box flexGrow={1} mr={1}>
            <Field label={messages.number}>
              <Input
                value={house.items.number?.value ?? ''}
                onChange={onChangeComponent({ key: HOUSE_ADDRESS_ITEMS.NUMBER })}
              />
            </Field>
          </Box>
          <Box flexGrow={1} ml={1}>
            <Field label={messages.neighborhood}>
              <Input
                value={photoSessionDetail.house.neighborhood}
                disabled
              />
            </Field>
          </Box>
        </Box>
        <Box my={3}>
          <Field label={messages.complement}>
            <Input
              value={house.items.complement?.value ?? ''}
              fullWidth
              onChange={onChangeComponent({ key: HOUSE_ADDRESS_ITEMS.COMPLEMENT })}
            />
          </Field>
        </Box>
        <Box my={3} width="50%">
          <Field label={messages.floor}>
            <Input
              value={house.items.floor?.value ?? ''}
              type="number"
              onChange={onChangeComponent({ key: HOUSE_ADDRESS_ITEMS.FLOOR })}
            />
          </Field>
        </Box>
      </ValidatorForm>
    </Fragment>
  );
};

HouseAddress.propTypes = {
  house: PropTypes.object,
  photoSessionDetail: PropTypes.shape({
    condoName: PropTypes.string,
    floor: PropTypes.number,
    complement: PropTypes.string,
  }).isRequired,
  onChangeItem: PropTypes.func,
  shouldValidate: PropTypes.bool,
  checkCondoNameIsValid: PropTypes.func,
};

export default HouseAddress;
